const financeCampaignSessionData = {
  settingsHash: "",
  canSimulate: false
};

const financeCampaignSimulateAvailable = () => {
  const selectedVehiclesRows = Array.from(document.querySelectorAll("#js-sel-vel-list tbody tr"));
  let gotPrices = true;
  Array.prototype.forEach.call(selectedVehiclesRows, el => {
    if (!el.querySelector("[data-driveaway] input")) {
      gotPrices = false;
    }
  });
  return (
    gotPrices &&
    !!document.querySelector(".js-campaign-term").value &&
    (!!document.querySelector(".js-campaign-kms").value || !!document.querySelector(".js-campaign-balloon").value) &&
    !!document.querySelector(".js-campaign-personal-fee").value &&
    !!document.querySelector(".js-campaign-daf").value &&
    !!document.querySelector(".js-campaign-monthly-fee").value
  );
};

const financeCampaignClearSimulation = () => {
  document.querySelector(".js-simulated-campaign-table").innerHTML = "";
  document.querySelector(".js-simulated-campaign-disclaimers").innerHTML = "";
  toggle("js-simulated-campaign", "none");
  if (financeCampaignSimulateAvailable()) {
    tdp_removeClass(document.querySelector(".js-simulate-campaign"), "disabled");
    financeCampaignSessionData.canSimulate = true;
  } else {
    tdp_addClass(document.querySelector(".js-simulate-campaign"), "disabled");
    financeCampaignSessionData.canSimulate = false;
  }
};

const financeCampaignGetPrices = () => {
  financeCampaignClearSimulation();
  tdp_addClass(document.querySelector(".js-simulate-campaign"), "disabled");
  const vehicleListContainer = document.getElementById("js-sel-vel-list");
  const priceCells = Array.from(document.querySelectorAll(".td-camp-driveaway"));
  Array.prototype.forEach.call(priceCells, cell => {
    cell.classList.remove("dollar");
    cell.innerHTML = `<div class="loading loading-full-width loading-small"><div class="typing_loader"></div></div>`; // eslint-disable-line
  });
  const specnumber = "";
  const postcode = document.getElementById("js-pricing-region").value;
  const vehicleArray = Array.from(vehicleListContainer.querySelectorAll("tbody tr"));
  const materialCodes = vehicleArray.map(v => v.getAttribute("data-mc"));
  if (postcode && postcode !== "Choose") {
    const pricingCalls = [];
    Array.prototype.forEach.call(materialCodes, (material, i) => {
      if (material) 
	  {
		 var url = "https://tdppricing.azurewebsites.net/api/pricing/"+material+"?pricingZone="+postcode;
        const pricingCall = axios
          .get(url)
          .then(response => {
            const row = vehicleArray[i];
            const dap = cents(response.data.DriveAwayPrice);
            row.querySelector("[data-driveaway]").innerHTML = `<input type="text" value="${dap}">`;
            row.querySelector("[data-driveaway]").classList.add("dollar");
          })
          .catch(error => {
            console.log(error); // eslint-disable-line
          });
        pricingCalls.push(pricingCall);
        if (i === materialCodes.length - 1) {
          Promise.all(pricingCalls).then(() => {
            if (financeCampaignSimulateAvailable()) {
              tdp_removeClass(document.querySelector(".js-simulate-campaign"), "disabled");
              financeCampaignSessionData.canSimulate = true;
            }
          });
        }
      }
    });
  }
};

function financeCampaignGetPricesHandler(e) {
  if (e.target.classList.contains("js-get-prices")) {
    e.preventDefault();
    financeCampaignGetPrices();
  }
}

const financeCampaignCheckChange = (firstLoad, isDeposit) => {
  const loantype = document.querySelector(".js-campaign-loantype").value;
 
  if (financeCampaignSessionData.canSimulate || firstLoad || isDeposit) {
    const settings = [
      document.querySelector(".js-campaign-agreed-rate").value,
      document.querySelector(".js-campaign-term").value,
      document.querySelector(".js-campaign-kms").value,
      document.querySelector(".js-campaign-personal-fee").value,
      document.querySelector(".js-campaign-balloon").value,
      document.querySelector(".js-campaign-daf").value,
      document.querySelector(".js-campaign-monthly-fee").value
    ];
    const selectedVehiclesRows = Array.from(document.querySelectorAll("#js-sel-vel-list tbody tr"));
    Array.prototype.forEach.call(selectedVehiclesRows, el => {
      settings.push(el.querySelector("[data-deposit] input").value);
    });
    if (financeCampaignSessionData.settingsHash !== settings.toString() || firstLoad) {
      financeCampaignClearSimulation();
      financeCampaignSessionData.settingsHash = settings.toString();
    } else if (financeCampaignSimulateAvailable() && !isDeposit) {
      tdp_removeClass(document.querySelector(".js-simulate-campaign"), "disabled");
    }
  }
};

function financeCampaignSimulateCampaign(e) {    
  const loantype = parseFloat(document.querySelector(".js-campaign-loantype").value);
  if (e.target.classList.contains("js-simulate-campaign")) {
    e.preventDefault();
    if (!financeCampaignSimulateAvailable()) {
      alert("Please make sure all campaign settings are filled in and prices retrieved before simulating."); // eslint-disable-line
    } else {
      document.querySelector(
        ".js-simulated-campaign-table"
      ).innerHTML = `<div class="loading loading-full-width"><div class="typing_loader"></div></div>`;
      toggleVisibility("js-simulated-campaign", true);
      const postcode = document.getElementById("js-pricing-region").value;
      const regionIndex = document.getElementById("js-pricing-region").selectedIndex;
      const region = document.getElementById("js-pricing-region").options[regionIndex].text;
      const date = document.querySelector(".js-campaign-validto").value;
      const vehicleListContainer = document.getElementById("js-sel-vel-list");
      const vehicleList = Array.from(vehicleListContainer.querySelectorAll("tbody tr"));
      const vehicles = [];
      Array.prototype.forEach.call(vehicleList, el => {
        const vehicle = {};
        vehicle.MaterialCode = el.getAttribute("data-mc") || 0;
        vehicle.Driveaway = el.querySelector(".td-camp-driveaway input")
          ? parseFloat(el.querySelector(".td-camp-driveaway input").value)
          : 0;
        vehicle.Deposit = el.querySelector(".js-dep-ent") ? parseFloat(el.querySelector(".js-dep-ent").value) : 0;
        vehicles.push(vehicle);
      });
      if (postcode && postcode !== "Choose") {
        const postObject = {
          Vehicles: vehicles,
          FinanceSettings: {
            mi: parseFloat(document.querySelector(".js-campaign-agreed-rate").value),
            mx: parseFloat(document.querySelector(".js-campaign-agreed-rate").value),
            ai: parseFloat(document.querySelector(".js-campaign-agreed-rate").value),
            da: parseFloat(document.querySelector(".js-campaign-daf").value),
            dp: parseFloat(document.querySelector(".js-campaign-deposit").value),
            tm: parseFloat(document.querySelector(".js-campaign-term").value),
            km:(parseFloat(document.querySelector(".js-campaign-loantype").value)== 3 || parseFloat(document.querySelector(".js-campaign-loantype").value) == 4) ? 0 : parseFloat(document.querySelector(".js-campaign-kms").value),
            lt: parseFloat(document.querySelector(".js-campaign-loantype").value),
            is: true,
            ic: true,
            bp: (parseFloat(document.querySelector(".js-campaign-loantype").value)== 3 || parseFloat(document.querySelector(".js-campaign-loantype").value) == 4) ? parseFloat(document.querySelector(".js-campaign-balloon").value) : 0,
            AdditionalDisclaimers: [],
            fe: {
              be: parseFloat(document.querySelector(".js-campaign-personal-fee").value),
              pe: parseFloat(document.querySelector(".js-campaign-personal-fee").value),
              ma: parseFloat(document.querySelector(".js-campaign-monthly-fee").value),
              zp: document.querySelector(".js-campaign-is-zeropc").checked
            }
          },
          Region: region,
          Postcode: postcode,
          Suburb: "",
          ValidTo: `${date}T00:00:00.603Z`
        };
        axios
          .post("https://tfscalculator-v2-stage.azurewebsites.net/api/CampaignSimulation", postObject)
          .then(response => {
            const loantype = postObject.FinanceSettings.lt;

            const results = response.data.CalculationResults;
            const campaignTableRows = Array.from(vehicleListContainer.querySelectorAll("tbody tr"));
            const gfvname =  (loantype == 3 || loantype == 4) ?'Balloon' :'GFV';
            let disclaimersHTML = "";
            let campaignTableRowsHTML = `<thead>
                                        <tr>
                                          <th>NVIC</th>
                                          <th>Material Code</th>
                                          <th>Model</th>
                                          <th>Grade</th>
                                          <th>Variant Description</th>
                                          <th>Driveaway (${region} ${postcode})</th>
                                          <th>Total Amount Financed</th>
                                          <th>Monthly Finance Payments</th>
                                          <th>Weekly Finance Payments</th>
                                          <th>Comparison Rate</th>
                                          <th>APR%</th>
                                          <th>${gfvname}</th>
                                          <th>Deposit</th>
                                          <th>Disclaimer</th>
                                          <th>Reviewed</th>
                                        </tr>
                                      </thead>
                                      <tbody>`;
            Array.prototype.forEach.call(campaignTableRows, (el, i) => {

              const mc = el.getAttribute("data-mc") || "";
              const nvic = el.querySelector("[data-nvic]").innerHTML || "";
              const mcs = el.querySelector("[data-fmc]").innerHTML || "";
              const model = el.querySelector("[data-name]").innerHTML || "";
              const grade = el.querySelector("[data-grade]").innerHTML || "";
              const description = el.querySelector("[data-variant-desc]").innerHTML || "";
              const dataIndex = results.findIndex(x => x.Vehicle.MaterialCode === mc);
              const d = results[dataIndex];
              const taf = cents(d.TotalAmountFinanced);
              const driveaway = cents(d.Vehicle.Driveaway);
              const monthly = cents(d.MonthlyPaymentAmountWithCents);
              const weekly = cents(d.PricePerWeek);
              const gfv = (d.Settings.LoanType == 3 ||d.Settings.LoanType == 4) ?  cents(d.Balloon):  cents(d.GFV);
              console.log(d);
             console.log("loantype :" + d.Settings.LoanType );
              console.log("Balloon :" + d.Balloon);
              console.log("GFV :" + d.GFV);
              const agreed = d.Settings ? d.Settings.AgreedInterestRatePa : 0;
              const deposit = d.Settings ? cents(d.Settings.Deposit) : d.ErrorCode ? d.ErrorCode.ErrorText : ""; // eslint-disable-line
              const depositClass = d.Settings ? "dollar" : "error";
              const html = `<tr>
                          <td>${nvic}</td>
                          <td class="td-mc">${mcs}</td>
                          <td>${model}</td>
                          <td>${grade}</td>
                          <td>${description}</td>
                          <td class="dollar">${driveaway}</td>
                          <td class="dollar">${taf}</td>
                          <td class="dollar">${monthly}</td>
                          <td class="dollar">${weekly}</td>
                          <td class="percent">${ (d.Settings.LoanType == 3 ||d.Settings.LoanType == 2) ? 'N/A' : d.ComparisonRatePercentage }</td>
                          <td class="percent">${agreed}</td>
                          <td class="dollar">${gfv}</td>
                          <td class="${depositClass}">${deposit}</td>
                          <td><a href="#disclaimer-${i}">[${i}]</a></td>
                          <td class="td-cb"><input type="checkbox" class="campaign-review" value="1"></td>
                        </tr>`;
              campaignTableRowsHTML += html;
              let disclaimers = "";
              Array.prototype.forEach.call(d.Disclaimers, disclaimer => {
                disclaimers += disclaimer.replace(/\[\F0\]/, `[F${i}]`);
              });
              disclaimersHTML += `<p id="disclaimer-${i}">${disclaimers}</p>`;
              document.querySelector(".js-simulate-comparison-rate").value = d.ComparisonRatePercentage;
            });
            const campaignTable = `<table>${campaignTableRowsHTML}</tbody></table>`;
            const campaignTableContainer = document.querySelector(".js-simulated-campaign-table");
            campaignTableContainer.innerHTML = campaignTable;
            const disclaimersContainer = document.querySelector(".js-simulated-campaign-disclaimers");
            disclaimersContainer.innerHTML = disclaimersHTML;
          })
          .catch(error => {
            console.log(error); // eslint-disable-line
            const campaignTableContainer = document.querySelector(".js-simulated-campaign-table");
            campaignTableContainer.innerHTML = `<p class="form-message form-message-error">There was a problem simulating the campaign.</p>`;
          });
      }
    }
  }
}

function financeCampaignSubmitForm(e) {
  e.preventDefault();

      // all checked
      window.removeEventListener("beforeunload", unloadMessage);

      toggle("spinnerBox", "block");
      toggle("js-submit-box", "none");
      toggle("js-vehi", "none");
      toggle("js-discy", "none");

      const selectedVehiclesRows = Array.from(document.querySelectorAll("#js-sel-vel-list tbody tr"));
      const vehicles = [];
      Array.prototype.forEach.call(selectedVehiclesRows, row => {
        const vehicleItem = {
          car: {
            materialcode: row.querySelector("[data-fmc]").innerText,
            vehicleName: row.querySelector("[data-name]").innerText,
            vehicleGrade: row.querySelector("[data-grade]").innerText,
            ModelDescription: row.querySelector("[data-model-desc]").innerText,
            VariantDescription: row.querySelector("[data-variant-desc]").innerText,
            Spec: row.querySelector("[data-spec]").innerText,
            PaintInc: row.querySelector("[data-paint-inc]").innerText,
            OptionInc: row.querySelector("[data-option-inc]").innerText,
            TotalInc: row.querySelector("[data-total-inc]").innerText
          },
          FormattedMaterialCode: row.querySelector("[data-fmc]").innerText,
          Deposit: row.querySelector("[data-deposit]").children[0].value,
          LeadCode: row.getAttribute("data-mc")
        };
        vehicles.push(vehicleItem);
      });

      const url = document.form.getAttribute("data-url");

      if (url) {
        axios
          .post(url, vehicles)
          .then(response => { // eslint-disable-line
            document.form.submit();
          })
          .catch(error => {
            console.log(error); // eslint-disable-line
            alert("There was a problem saving the campaign."); // eslint-disable-line
          });
      }
  
}

tdp_ready(() => {
  if (document.querySelector(".js-campaign-finance-edit")) {
    if (document.getElementById("js-sel-vel-list").innerHTML.trim() === "") {
      toggleVisibility("js-selected-vehicles", false);
    }
    document.getElementsByTagName("body")[0].addEventListener("click", financeCampaignGetPricesHandler);
    document.getElementsByTagName("body")[0].addEventListener("click", financeCampaignSimulateCampaign);
    document.form.addEventListener("submit", financeCampaignSubmitForm);

    document.querySelector(".js-campaign-term").addEventListener("change", financeCampaignCheckChange);
    document.querySelector(".js-campaign-kms").addEventListener("change", financeCampaignCheckChange);
    document.querySelector(".js-campaign-agreed-rate").addEventListener("blur", financeCampaignCheckChange);
    document.querySelector(".js-campaign-personal-fee").addEventListener("blur", financeCampaignCheckChange);
    document.querySelector(".js-campaign-daf").addEventListener("blur", financeCampaignCheckChange);
    document.querySelector(".js-campaign-monthly-fee").addEventListener("blur", financeCampaignCheckChange);

    financeCampaignCheckChange(true);
  }
});
